import React, { useState, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import { Button, Badge } from "react-bootstrap";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import swal from "sweetalert2";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import Add from '../../../../modal/Settings/Package_Management/Item_Category/AddItemCat';
import Edit from '../../../../modal/Settings/Package_Management/Item_Category/EditItemCat';
import EditItemCat from '../../../../modal/Settings/Package_Management/Item_Category/EditItemCat';
import AddItemCat from '../../../../modal/Settings/Package_Management/Item_Category/AddItemCat';
import AddSubCategory from '../../../../modal/Production_Management/Manage_Items/AddSubCat';
import AddItemSubCat from '../../../../modal/Production_Management/Manage_Items/AddSubCat';
import AddItem from '../../../../modal/Production_Management/Manage_Items/AddItem';
import ViewItemCategory from '../../../../modal/Production_Management/Manage_Items/ViewItemCat';
// import AddItem from './../../../modal/Production_Management/Manage_Items/AddItem';
import axios from 'axios';
import { Row, Col, Tab, Nav, Dropdown } from "react-bootstrap";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ItemCategory = () => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const tableRef = useRef(null);
    const [page, setPage] = useState(1); //pagination
    const [totalPages, setTotalPages] = useState(1); //pagination
    const [searchTerm, setSearchTerm] = useState(''); //pagination
    const [perPage, setPerPage] = useState(25); //pagination
    const [itemCategories, setItemCategories] = useState([]);
    const [open, setOpen] = useState(false);
    const [modalType, setModalType] = useState("");
    const [editModalShow, setEditModalShow] = useState(false);
    const [currentItemId, setCurrentItemId] = useState(null);
    const [file, setFile] = useState(null);

    const handleModalToggle = () => {
        setModalType("Add");
        setOpen(true);
    };

    const handleModalToggle_Edit = () => {
        setModalType("Edit");
        setOpen(true);
    };

    const [modalOpen, setModalOpen] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);

    const handleModalToggleAddSubCat = async (categoryId) => {
        try {

            const response = await fetch(`${baseURL}/item-categories/${categoryId}`);
            if (!response.ok) throw new Error('Failed to fetch category');

            const data = await response.json();

            setSelectedCategory(data.data);
            setModalType('AddSubCategory');
            setModalOpen(true);
        } catch (error) {
            console.error('Error fetching category:', error);
        }
    };

    const handleCloseModal = () => {
        setModalOpen(false);
        setSelectedCategory(null);
        setModalType('');
    };

    const [selectedCategoryId, setSelectedCategoryId] = React.useState(null);

    const handleModalToggleAdd = () => {
        setModalType("AddItem");
        setOpen(true);
    };

    const handleViewItemCatModal = (id) => {
        setSelectedCategoryId(id);
        setModalType("ViewItem"); // <<< Add this line!
        setOpen(true);
    };

    const DeleteModal = (categoryId, categoryName) => {
        swal.fire({

            html: `
                <div class="alert alert-danger px-2 py-2" role="alert">
                    <strong>OOPS! </strong> You're about to lose one Item Category
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <p class="text-center"><b>${categoryName}</b></p>  
                <div class="text-center">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48">
                        <defs>
                            <radialGradient id="radial-gradient" cx="-27.957" cy="8.563" r="6" gradientTransform="matrix(3 0 0 2.5 107.871 -4.408)" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#5987dd"/>
                                <stop offset=".118" stop-color="#638bd6"/>
                                <stop offset=".316" stop-color="#7d98c3"/>
                                <stop offset=".572" stop-color="#a8aba3"/>
                                <stop offset=".871" stop-color="#e3c678"/>
                                <stop offset="1" stop-color="#ffd364"/>
                            </radialGradient>
                            <style>.cls-3{fill:#ffb32b}.cls-4{fill:#273941}.cls-5{fill:#141e21}.cls-6{fill:#f6fafd}</style>
                        </defs>
                        <g id="_27-feel_bad" data-name="27-feel bad">
                            <circle cx="24" cy="24" r="23" style="fill:#ffce52"/>
                            <ellipse cx="24" cy="17" rx="18" ry="15" style="fill:url(#radial-gradient)"/>
                            <path class="cls-3" d="M46 23c0 10.493-9.85 19-22 19S2 33.493 2 23h-.975c-.014.332-.025.665-.025 1a23 23 0 0 0 46 0c0-.335-.011-.668-.025-1z"/>
                            <ellipse class="cls-4" cx="33" cy="23" rx="3" ry="4"/>
                            <ellipse class="cls-5" cx="33" cy="23" rx="2" ry="3"/>
                            <circle class="cls-6" cx="34" cy="22" r="1"/>
                            <ellipse class="cls-4" cx="15" cy="23" rx="3" ry="4"/>
                            <ellipse class="cls-5" cx="15" cy="23" rx="2" ry="3"/>
                            <circle class="cls-6" cx="16" cy="22" r="1"/>
                            <path class="cls-5" d="M10 19v-2c3.722 0 6-1.295 6-2h2c0 2.626-4.024 4-8 4zM38 19c-3.976 0-8-1.374-8-4h2c0 .705 2.278 2 6 2z"/>
                            <path class="cls-4" d="M24 35h-5.5a5.265 5.265 0 0 1 5.5-5 5.265 5.265 0 0 1 5.5 5z"/>
                            <path class="cls-5" d="M24 31a5.4 5.4 0 0 1 5.39 4h.11a5.265 5.265 0 0 0-5.5-5 5.265 5.265 0 0 0-5.5 5h.11A5.4 5.4 0 0 1 24 31z"/>
                            <path d="M47 12a4 4 0 0 1-8 0c0-2.209 3-8 4-8s4 5.791 4 8z" style="fill:#3bc5f6"/>
                            <path d="M43 4c-1 0-4 5.791-4 8a4 4 0 0 0 8 0c0-2.209-3-8-4-8zm0 8.5a2.848 2.848 0 0 1-3-2.667C40 8.361 42.25 4.5 43 4.5s3 3.861 3 5.333a2.848 2.848 0 0 1-3 2.667z" style="fill:#00a3e1"/>
                            <path class="cls-3" d="M43 16a3.991 3.991 0 0 1-3.861-3.008A4.661 4.661 0 0 0 39 14a4 4 0 0 0 6.846 2.807q-.255-.777-.562-1.529A3.982 3.982 0 0 1 43 16z"/>
                            <ellipse class="cls-6" cx="44" cy="11" rx=".825" ry="1.148" transform="rotate(-45.02 44 11)"/>
                            <ellipse class="cls-6" cx="44.746" cy="9.5" rx=".413" ry=".574" transform="rotate(-45.02 44.746 9.5)"/>
                            <ellipse class="cls-6" cx="36" cy="9" rx=".825" ry="1.148" transform="rotate(-45.02 36 9)"/>
                            <ellipse class="cls-6" cx="29.746" cy="4.5" rx=".413" ry=".574" transform="rotate(-45.02 29.746 4.5)"/>
                            <ellipse class="cls-6" cx="33" cy="7" rx="1.65" ry="2.297" transform="rotate(-45.02 33 7)"/>
                        </g>
                    </svg>
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-danger',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (result.isConfirmed) {
                // 🔥 Call DELETE API
                axios.delete(`${baseURL}/item-categories/${categoryId}`)
                    .then(() => {
                        swal.fire({
                            title: 'Product Category Deleted!',
                            text: `${categoryName} has been marked as deleted.`,
                            icon: 'success',
                            confirmButtonText: 'OK',
                            customClass: {
                                title: 'fs-6',
                                confirmButton: 'btn btn-sm btn-primary',
                            },
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        }).then(() => {
                            softRefresh(); // or fetchCategories() to refresh your list
                        });
                    })
                    .catch((error) => {
                        console.error("Delete failed:", error);
                        // Extract message from backend response (adjust path based on your backend error structure)
                        const errorMsg = error.response?.data?.message || 'Something went wrong while deleting.';
                        swal.fire({
                            title: 'Error!',
                            text: errorMsg,
                            icon: 'error',
                            confirmButtonText: 'OK',
                            customClass: {
                                title: 'fs-6',
                                confirmButton: 'btn btn-sm btn-primary',
                            },
                        });
                    });
            } else {
                swal.fire({
                    title: 'Delete Cancelled',
                    text: `${categoryName} was not deleted.`,
                    icon: 'info',
                    confirmButtonText: 'OK',
                    customClass: {
                        title: 'fs-6',
                        confirmButton: 'btn btn-sm btn-primary',
                    },
                });
            }
        });
    };

    const handleEditItemCategory = (itemId) => {
        setEditModalShow(true);
        setCurrentItemId(itemId);
    };

    const [hasFetched, setHasFetched] = useState(false);
    const softRefresh = () => {
        setHasFetched(false);
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        fetchCategories();
    }

    const [totalEntries, setTotalEntries] = useState(0);

    const fetchCategories = async (pageNumber = 1, perPageCount = 25, search = '') => {
        // console.log('Fetching with:', { pageNumber, perPageCount, search });

        try {
            const response = await axios.get(`${baseURL}/item-categories`, {
                params: {
                    page: pageNumber,
                    per_page: perPageCount,
                    search: search,
                },
            });
            const data = response.data;
            setItemCategories(data.data || []);
            setTotalPages(data.pagination?.last_page || 1);
            setTotalEntries(data.pagination?.total || 0);
            setHasFetched(true);
        } catch (error) {
            console.error('Error fetching item categories:', error);
        }
    };

    useEffect(() => {
        fetchCategories(page, perPage, searchTerm);
    }, [page, searchTerm, perPage]);


    useEffect(() => {
        let dataTableInstance;

        if (itemCategories.length > 0 && tableRef.current) {
            if ($.fn.DataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable().clear().destroy(); // ✅ Safe cleanup
            }

            dataTableInstance = $(tableRef.current).DataTable({
                // responsive: true,
                // ordering: false,
                destroy: true,
                responsive: true,
                pageLength: 25,
                ordering: false,
                language: {
                    "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                },
                dom:
                    "<'row'" +
                    "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                    "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                    ">" +
                    "<'table-responsive'tr>" +
                    "<'row'" +
                    "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                    "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                    ">"
            });
        }

        return () => {
            if ($.fn.DataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable().destroy(); // ✅ Cleanup on unmount
            }
        };
    }, [itemCategories]);

    const handleStatusChange = (categoryId, currentStatus) => {
        const newStatus = currentStatus === 0 ? 1 : 0;

        axios.put(`${baseURL}/item-categories/status/${categoryId}`, { status: newStatus })
            .then(() => {
                toast.success("Status Updated Successfully!");
                fetchCategories();
            })
            .catch(error => {
                console.log("Error updating status:", error);
                toast.error("Status Updation Failed");
            });
    };

    const [itemcategoryCount, setItemCategoryCount] = useState(0); // used for item category count
    const [itemsubcategoryCount, setItemSubCategoryCount] = useState(0);  // used for item sub category data
    const [itemCount, setItemCount] = useState(0);
    const [itemScheduleCount, setItemScheduleCount] = useState(0);

    useEffect(() => {
        axios.get(`${baseURL}/manage-items`)
            .then(response => {
                const data = response.data;

                if(data.pagination){
                    setItemCount(data.pagination?.total);
                } else {
                    setItemCount(0);
                }

            })
            .catch(error => {
                console.log("Error fetching item categories:", error);
                // setProductCategories([]);  // Default to an empty list in case of error
                setItemCount(0);  // Default to 0 in case of error
            });
    }, []);  // Only run once on mount

    useEffect(() => {
        axios.get(`${baseURL}/item-categories`)
            .then(response => {
                const data = response.data;

                // Check if the response contains product categories correctly
                if (Array.isArray(data)) {
                    // setProductCategories(data);  // Set the product categories list
                    setItemCategoryCount(data.length);  // Set category count based on the array length
                } else if (Array.isArray(data?.data)) {
                    // setProductCategories(data.data);  // Set product categories if nested in 'data'
                    setItemCategoryCount(data.data.length);  // Set category count based on the nested array
                } else {
                    console.warn("Unexpected response format for categories:", data);
                    // setProductCategories([]);  // Default to an empty list
                    setItemCategoryCount(0);  // Default to 0 in case of unexpected response
                }
            })
            .catch(error => {
                console.error("Error fetching item categories:", error);
                // setProductCategories([]);  // Default to an empty list in case of error
                setItemCategoryCount(0);  // Default to 0 in case of error
            });
    }, []);  // Only run once on mount

    useEffect(() => {
        axios.get(`${baseURL}/item-subcategories`)
            .then(response => {
                const data = response.data;

                // Check if the response contains product categories correctly
                if (Array.isArray(data)) {
                    // setProductCategories(data);  // Set the product categories list
                    setItemSubCategoryCount(data.length);  // Set category count based on the array length
                } else if (Array.isArray(data?.data)) {
                    // setProductCategories(data.data);  // Set product categories if nested in 'data'
                    setItemSubCategoryCount(data.data.length);  // Set category count based on the nested array
                } else {
                    console.warn("Unexpected response format for categories:", data);
                    // setProductCategories([]);  // Default to an empty list
                    setItemSubCategoryCount(0);  // Default to 0 in case of unexpected response
                }
            })
            .catch(error => {
                console.error("Error fetching item sub categories:", error);
                // setProductCategories([]);  // Default to an empty list in case of error
                setItemSubCategoryCount(0);  // Default to 0 in case of error
            });
    }, []);  // Only run once on mount

    useEffect(() => {
        axios.get(`${baseURL}/item-schedule`)
            .then(response => {
                const data = response.data;

                // Check if the response contains product categories correctly
                if (Array.isArray(data)) {
                    // setProductCategories(data);  // Set the product categories list
                    setItemScheduleCount(data.length);  // Set category count based on the array length
                } else if (Array.isArray(data?.data)) {
                    // setProductCategories(data.data);  // Set product categories if nested in 'data'
                    setItemScheduleCount(data.data.length);  // Set category count based on the nested array
                } else {
                    console.warn("Unexpected response format for schedule:", data);
                    // setProductCategories([]);  // Default to an empty list
                    setItemScheduleCount(0);  // Default to 0 in case of unexpected response
                }
            })
            .catch(error => {
                console.error("Error fetching item schedule:", error);
                // setProductCategories([]);  // Default to an empty list in case of error
                setItemScheduleCount(0);  // Default to 0 in case of error
            });
    }, []);  // Only run once on mount

    const handleAddSuccess = () => {
        console.log("Add success called!");
        toast.success("Item category added successfully!");
        setOpen(false);
        softRefresh();
    };

    const [languageCode, setLanguageCode] = useState();
    const fetchCategoriesByLanguage = async () => {
        try {
            const response = await axios.get(`${baseURL}/item-categories`, {
                params: {
                    language_code: languageCode,
                },
            });
            const data = response.data;
            setItemCategories(data.data || []);
            setTotalPages(data.pagination?.last_page || 1);
            setTotalEntries(data.pagination?.total || 0);
            setHasFetched(true);
        } catch (error) {
            console.error(`Error fetching item categories with language_code=${languageCode}:`, error);
        }
    };

    const [languages, setLanguages] = useState([]);  // Store languages 

    useEffect(() => {
        axios
            .get(`${baseURL}/language/active/list`) // API endpoint to fetch active languages
            .then((response) => {
                // Assuming response.data.data is an array of languages
                setLanguages(response.data.data || []);
            })
            .catch((error) => {
                console.error("Error fetching languages:", error);
            });
    }, []);

    const handleLanguageChange = (newLangCode) => {
        setLanguageCode(newLangCode); // Set the selected language code

        // Fetch categories based on new language code
        axios
            .get(`${baseURL}/item-categories`, {
                params: {
                    language_code: newLangCode,
                },
            })
            .then((response) => {
                setItemCategories(response.data.data || []);
                setHasFetched(true);
            })
            .catch((error) => {
                console.error(`Error fetching item categories with language_code=${newLangCode}:`, error);
            });
    };
    const [key, setKey] = useState('item_category');

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0 flex-wrap">
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                    <div className='mb-2'>
                        <div className="mb-0 px-0">
                            <h4 style={{ color: '#025d3a' }}>Manage Items</h4>
                        </div>
                        <ol className="breadcrumb fs-7">
                            <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                            <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                            <li className="breadcrumb-item active">Package Management</li>
                        </ol>
                    </div>

                    <div className='d-flex align-items-center gap-3 mb-2'>

                        <Dropdown>
                            <Dropdown.Toggle
                                as="button"
                                variant="primary"
                                className="btn btn-primary text-white btn-sm"
                                id="tp-btn"
                            >
                                <span className="me-2">
                                    <i className="fa-solid fa-globe mt-1 fs-3 px-0 py-0"></i>
                                </span>
                                {languages.find((lang) => lang.language_code === languageCode)?.language_name}
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                {languages.map((lang) => (
                                    <Dropdown.Item
                                        key={lang.language_code}
                                        href="#"
                                        className="px-0 py-2"
                                        onClick={() => handleLanguageChange(lang.language_code)}
                                    >
                                        <span className="fs-7 ms-2 font-w500 text-black">{lang.language_name}</span>
                                    </Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </Dropdown>

                    </div>
                </div>

                {open && modalType === "Add" && (
                    <Add show={open} onClose={() => setOpen(false)} onSuccess={handleAddSuccess} />
                )}

                {open && modalType === "Edit" && (
                    <Edit show={open} onClose={() => setOpen(false)} />
                )}

                {open && modalType === "AddSubCategory" && (
                    <AddSubCategory show={open} onClose={() => setOpen(false)} onSuccess={handleAddSuccess} />
                )}

                {open && modalType === "AddItem" && (
                    <AddItem show={open} onClose={() => setOpen(false)} />
                )}

                {open && modalType === "ViewItem" && (
                    <ViewItemCategory
                        show={open}
                        onClose={() => setOpen(false)}
                        categoryId={selectedCategoryId}
                    />
                )}

            </div>


            <Col xl={12} className='mb-3'>
                <div className="custom-tab-1">
                    <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                        <Nav as="ul" className="nav-tabs mb-4">
                            <Nav.Item as="li" >
                                <Nav.Link >
                                    <Link to="/manage-items" className="d-flex align-items-center text-decoration-none">
                                        <i className="fa-solid fa-bowl-rice me-3" />
                                        <label className="fs-6">
                                            Items
                                        </label>
                                        <Badge as="a" href="" bg=" badge-circle" className='badge-outline-danger ms-2 fw-bold fs-8'>
                                            {String(itemCount).padStart(2, '0')}
                                        </Badge>
                                    </Link>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link eventKey="item_category">
                                    <Link to="/item-category" className="d-flex align-items-center text-decoration-none">
                                        <i className="fa-solid fa-kitchen-set me-3" />
                                        <label className="fs-6">
                                            Item Category
                                        </label>
                                        <Badge as="a" href="" bg=" badge-circle" className='badge-outline-danger ms-2 fw-bold fs-8'>
                                            {String(itemcategoryCount).padStart(2, '0')}
                                        </Badge>
                                    </Link>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link >
                                    <Link to="/item-sub-category" className="d-flex align-items-center text-decoration-none">
                                        <i className="fa-solid fa-plate-wheat me-3" />
                                        <label className="fs-6">
                                            Item Sub Category
                                        </label>
                                        <Badge as="a" href="" bg=" badge-circle" className='badge-outline-danger ms-2 fw-bold fs-8'>
                                            {String(itemsubcategoryCount).padStart(2, '0')}
                                        </Badge>
                                    </Link>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link >
                                    <Link to="/item-schedule" className="d-flex align-items-center text-decoration-none">
                                        <svg className="me-2" width="25px" height="25px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 8V12L14.5 14.5" stroke="#025d3a" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z" stroke="#025d3a" stroke-width="1.5"></path> </g></svg>
                                        <label className="fs-6">
                                            Item Schedule
                                        </label>
                                        <Badge as="a" href="" bg=" badge-circle" className='badge-outline-danger ms-2 fw-bold fs-8'>
                                            {String(itemScheduleCount).padStart(2, '0')}
                                        </Badge>
                                    </Link>
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                        <Tab.Content className="pt-4">
                            <Tab.Pane eventKey="item_category">
                                <Row>
                                    <Col xl={12} className='mb-3 d-flex align-items-end justify-content-end gap-3'>
                                        <Link to={"#"} className="btn btn-primary float-end btn-sm mb-2" onClick={handleModalToggle}>
                                            <span className='me-2'><i className="fa-solid fa-plus fs-8"></i></span>
                                            <span>Add Item Category</span>
                                        </Link>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="table-container">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                {/* Left: Show entries dropdown */}
                                                <div>
                                                    <label className="me-2">Show</label>
                                                    <select
                                                        className="form-select d-inline w-auto"
                                                        style={{ fontSize: '0.85rem', height: '30px' }}
                                                        value={perPage}
                                                        onChange={(e) => {
                                                            setPerPage(Number(e.target.value));
                                                            setPage(1); // Reset to first page
                                                        }}
                                                    >
                                                        <option value={25}>25</option>
                                                        <option value={50}>50</option>
                                                        <option value={75}>75</option>
                                                        <option value={100}>100</option>
                                                    </select>
                                                </div>

                                                {/* Right: Search input */}
                                                <div>
                                                    <input
                                                        type="text"
                                                        style={{ fontSize: '0.85rem', height: '40px' }}
                                                        placeholder="Search..."
                                                        className="form-control"
                                                        value={searchTerm}
                                                        onChange={(e) => {
                                                            setSearchTerm(e.target.value);
                                                            setPage(1); // Reset page on new search
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            <table id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable" style={{ borderBottom: '2px solid #ddd', overflowX: 'scroll' }}>
                                                <thead>
                                                    <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">

                                                        <th className='min-w-100px'>Item Category</th>
                                                        <th className='min-w-100px text-center'>ISC Count/ Item Count</th>
                                                        <th className='min-w-200px'>Description</th>
                                                        <th className='min-w-100px'>Status</th>
                                                        <th className='min-w-100px'>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="text-gray-600 fw-semibold fs-7">
                                                    {itemCategories.map((category, idx) => (
                                                        <tr key={category.sno}>

                                                            <td>
                                                                <label className='text-black font-w400 fs-7'>{category.itemcategory_name}</label>
                                                            </td>

                                                            <td className='text-center'>
                                                                {(category.subcategory_count === 0 && category.item_count === 0) ? (
                                                                    <span>-</span>
                                                                ) : (
                                                                    <>
                                                                        <Badge bg="success" className='text-white fs-7 py-0 px-2'>
                                                                            {category.subcategory_count > 0 ? category.subcategory_count : 0}
                                                                        </Badge>
                                                                        /
                                                                        <Badge bg="success" className='text-white fs-7 py-0 px-2'>
                                                                            {category.item_count > 0 ? category.item_count : 0}
                                                                        </Badge>
                                                                    </>
                                                                )}
                                                            </td>

                                                            <td>
                                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover'><span className='fs-8 text-white fw-semibold'>{category.description || "No description available."}</span></Tooltip>}>
                                                                    <div className='text-truncate mw-450px text-black font-w400 fs-7'>{category.description || "No description available."}</div>
                                                                </OverlayTrigger>
                                                            </td>
                                                            <td>
                                                                <div className="form-check form-switch d-flex align-items-center mb-3">
                                                                    <input
                                                                        className="form-check-input me-2"
                                                                        type="checkbox"
                                                                        role="switch"
                                                                        checked={category.status == 0}
                                                                        onChange={() => handleStatusChange(category.sno, category.status)}
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <span className="text-end d-flex">
                                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>View</span></Tooltip>} >
                                                                        <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleViewItemCatModal(category.sno)}>
                                                                            <span><i class="fa-solid fa-eye fs-6 mt-1"></i></span>
                                                                        </Button>
                                                                    </OverlayTrigger>
                                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover'><span className='fs-8 text-white fw-semibold'>Edit</span></Tooltip>}>
                                                                        <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleEditItemCategory(category.sno)}>
                                                                            <i className="fa-solid fa-pen-to-square fs-6"></i>
                                                                        </Button>
                                                                    </OverlayTrigger>
                                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover'><span className='fs-8 text-white fw-semibold'>Delete</span></Tooltip>}>
                                                                        <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => DeleteModal(category.sno, category.itemcategory_name)}>
                                                                            <i className="fa-solid fa-trash-can fs-6 mt-1"></i>
                                                                        </Button>
                                                                    </OverlayTrigger>
                                                                    <Dropdown drop=''>
                                                                        <Dropdown.Toggle
                                                                            as="a"
                                                                            className="i-false cursor-pointer"
                                                                        >
                                                                            <Button variant="primary tp-btn-light px-3 py-2">
                                                                                <span><i class="fa-solid fa-ellipsis-vertical fs-6 mt-1"></i></span>
                                                                            </Button>
                                                                        </Dropdown.Toggle>
                                                                        <Dropdown.Menu>
                                                                            <Dropdown.Item href={'#'} className='px-2 py-1' onClick={() => handleModalToggleAddSubCat(category.sno)}>
                                                                                <div className='d-flex align-items-center'>
                                                                                    <div className="rounded px-1 py-1 text-center bg-transparent me-0">
                                                                                        <span>  <svg className="me-2" fill="#228b22" width="20px" height="20px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" stroke="#228b22" stroke-width="0.352"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M15.35,2.45s0,0-.01-.01c-.05-.08-.11-.15-.18-.21,0,0,0,0,0,0-.04-.03-.09-.05-.14-.07-.04-.02-.07-.05-.11-.06,0,0,0,0,0,0,0,0-.01,0-.02,0-2.37-.67-4.63,.22-5.15,2.04-.51,1.81,.92,3.74,3.26,4.44,0,0,.01,0,.02,0,.01,0,.03,.01,.04,.01,.07,.02,.13,.03,.2,.03,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.04,0,.09,0,.13-.01,.02,0,.03-.01,.04-.02,.06-.02,.12-.04,.18-.07,.02-.01,.05-.02,.07-.04,.14-.1,.25-.23,.3-.41,0,0,0-.01,0-.02,.01-.05,0-.1,.01-.15,0-.05,.01-.1,0-.15,0,0,0-.01,0-.02l-.17-.98,.65-.43c.27-.18,.4-.52,.31-.83l-.33-1.15,.82-1.05s0,0,0-.01h0s.02-.04,.03-.05c.04-.06,.08-.13,.1-.2,0,0,0,0,0,0,.02-.09,.03-.18,.02-.27,0-.11-.04-.21-.09-.3Zm-4.18,2.09c.21-.72,1.08-1.16,2.14-1.17l-.27,.34c-.15,.19-.2,.44-.13,.67l.28,.99-.61,.4c-.25,.16-.38,.46-.33,.76v.05c-.81-.56-1.28-1.35-1.08-2.04Z"></path><path d="M16.64,8.75s-.04,.07-.06,.11c0,0,0,0,0,0-.02,.09-.03,.18-.02,.26,0,.07,.03,.13,.05,.19,.02,.04,.03,.09,.05,.13,.05,.08,.1,.15,.17,.2,0,0,0,0,0,0,.07,.06,.16,.1,.24,.12,0,0,0,0,.01,0,.54,.15,1.07,.23,1.58,.23,1.74,0,3.19-.85,3.59-2.26,.52-1.82-.94-3.78-3.32-4.46,0,0-.01,0-.02,0-.05-.01-.1,0-.15-.01-.05,0-.1-.01-.15,0,0,0-.01,0-.02,0-.03,0-.06,.03-.09,.04-.06,.02-.11,.03-.16,.06-.04,.02-.07,.05-.1,.08-.04,.03-.08,.07-.11,.11-.03,.04-.05,.09-.07,.14-.02,.03-.04,.06-.05,.1,0,0,0,.01,0,.02-.01,.05,0,.1-.01,.15,0,.05-.01,.1,0,.15,0,0,0,.01,0,.02l.17,.98-.65,.43c-.27,.18-.4,.52-.31,.83l.33,1.15-.83,1.07s-.05,.1-.07,.15Zm4.19-1.41c-.21,.72-1.08,1.16-2.14,1.17l.27-.35c.15-.19,.2-.44,.13-.67l-.28-.99,.61-.4c.25-.16,.38-.46,.33-.76v-.05c.81,.56,1.28,1.35,1.08,2.04Z"></path><path d="M14.71,8.51c-1.15,0-2.05,1.13-2.05,2.57s.9,2.57,2.05,2.57,2.05-1.13,2.05-2.57-.9-2.57-2.05-2.57Zm0,3.65c-.22,0-.55-.43-.55-1.07s.33-1.07,.55-1.07,.55,.43,.55,1.07-.33,1.07-.55,1.07Z"></path><path d="M27.76,15.06H4.24c-.41,0-.75,.34-.75,.75,0,4.96,2.91,9.25,7.11,11.27v2.84c0,.41,.34,.75,.75,.75h9.31c.41,0,.75-.34,.75-.75v-2.85c4.19-2.02,7.1-6.3,7.1-11.26,0-.41-.34-.75-.75-.75Zm-7.85,14.11h-7.81v-1.48c1.23,.4,2.54,.63,3.9,.63s2.68-.23,3.91-.63v1.48Zm-3.91-2.35c-5.82,0-10.6-4.54-10.99-10.26H26.99c-.39,5.72-5.17,10.26-10.99,10.26Z"></path><path d="M8,18.95h15.98c.41,0,.75-.34,.75-.75s-.34-.75-.75-.75H8c-.41,0-.75,.34-.75,.75s.34,.75,.75,.75Z"></path></g></svg>
                                                                                        </span>
                                                                                    </div>
                                                                                    <div className="ms-1 fs-7">Add Sub Category</div>
                                                                                </div>
                                                                            </Dropdown.Item>
                                                                            <Dropdown.Item href={"#"} className='px-2 py-1' onClick={handleModalToggleAdd}>
                                                                                <div className='d-flex align-items-center'>
                                                                                    <div className="rounded px-1 py-1 text-center bg-transparent me-0">
                                                                                        <span> <svg height='20px' width='20px' className='me-2' fill="#228b22" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" stroke="#228b22" stroke-width="0.32"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M26.01,15.24H6c-.41,0-.75,.34-.75,.75,0,4.24,2.47,7.91,6.05,9.66v2.35c0,.41,.34,.75,.75,.75h7.92c.41,0,.75-.34,.75-.75v-2.35c3.57-1.75,6.04-5.41,6.04-9.65,0-.41-.34-.75-.75-.75Zm-6.79,12.01h-6.42v-.99c1.01,.32,2.09,.49,3.21,.49s2.2-.17,3.22-.49v.99Zm-3.22-2c-4.13,0-7.63-2.72-8.82-6.47h14.69c.41,0,.75-.34,.75-.75s-.34-.75-.75-.75H6.85c-.03-.18-.05-.36-.07-.54H25.23c-.38,4.75-4.37,8.51-9.23,8.51Z"></path><path d="M25.55,5.23H14.99v-.13c0-1.02-.83-1.85-1.85-1.85-.41,0-.79,.14-1.1,.37-.31-.23-.69-.37-1.1-.37s-.79,.14-1.1,.37c-.31-.23-.69-.37-1.1-.37s-.79,.14-1.1,.37c-.31-.23-.69-.37-1.1-.37-1.02,0-1.85,.83-1.85,1.85v3.86c0,1.02,.83,1.85,1.85,1.85,.41,0,.79-.14,1.1-.37,.31,.23,.69,.37,1.1,.37s.79-.14,1.1-.37c.31,.23,.69,.37,1.1,.37s.79-.14,1.1-.37c.31,.23,.69,.37,1.1,.37,1.02,0,1.85-.83,1.85-1.85v-.2h10.57c.97,0,1.77-.79,1.77-1.77s-.79-1.77-1.77-1.77ZM6.53,9.32c-.19,0-.35-.16-.35-.35v-3.86c0-.19,.16-.35,.35-.35s.35,.16,.35,.35v3.86c0,.19-.16,.35-.35,.35Zm2.2,0c-.19,0-.35-.16-.35-.35v-3.86c0-.19,.16-.35,.35-.35s.35,.16,.35,.35v3.86c0,.19-.16,.35-.35,.35Zm2.2,0c-.19,0-.35-.16-.35-.35v-3.86c0-.19,.16-.35,.35-.35s.35,.16,.35,.35v3.86c0,.19-.16,.35-.35,.35Zm2.55-.35c0,.19-.16,.35-.35,.35s-.35-.16-.35-.35v-3.86c0-.19,.16-.35,.35-.35s.35,.16,.35,.35v3.86Zm12.07-1.7H14.99v-.53h10.57c.15,0,.27,.12,.27,.27s-.12,.27-.27,.27Z"></path></g></svg></span>
                                                                                    </div>
                                                                                    <div className="ms-1 fs-7">Add Item</div>
                                                                                </div>
                                                                            </Dropdown.Item>
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>

                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                {/* Bottom left: Showing x to y of z entries */}
                                                <div>
                                                    {itemCategories.length > 0 && (
                                                        <span className="text-muted">
                                                            Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + itemCategories.length} of {totalEntries} entries
                                                        </span>
                                                    )}
                                                </div>


                                                {/* Bottom right: Pagination */}
                                                <nav>
                                                    <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                                        <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                                                        </li>
                                                        {[...Array(totalPages)].map((_, i) => (
                                                            <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                                                            </li>
                                                        ))}
                                                        <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                                                        </li>
                                                    </ul>
                                                </nav>

                                            </div>

                                            <AddItemSubCat
                                                show={modalOpen && modalType === 'AddSubCategory'}
                                                onClose={handleCloseModal}
                                                category={selectedCategory}
                                            />

                                            <EditItemCat
                                                show={editModalShow}
                                                onClose={() => setEditModalShow(false)}
                                                itemId={currentItemId}
                                                onUpdated={fetchCategories}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </div>
            </Col>
        </>
    );
};

export default ItemCategory;
